import EmphasizedContent from '@blocks/EmphasizedContent'
import Grid from '@blocks/Grid'
import React from 'react'

export default function MembersDelivery({ salon }: Props) {
    if (!salon.trackings.length)
        return null

    return (
        <EmphasizedContent>
            <Grid gap="10px">
                <Grid columns="4">
                    <Grid gap="5px">
                        <h4>Delivery</h4>
                        <small>You can track awards to the group's members.</small>
                    </Grid>
                </Grid>
                <Grid columns="4">
                    {salon.trackings.map((tracking, idx) => (
                        <EmphasizedContent padding="10px" background="#fff" key={idx}>
                            <small>Tracking number: <a href="https://track.ukrposhta.ua/tracking_EN.html" target="_blank">{tracking.number}</a>.</small>
                            {tracking.comment && <small>Comment: {tracking.comment}</small>}
                            <small>Contents: {tracking.contents.join(', ')}</small>
                        </EmphasizedContent>
                    ))}
                </Grid>
            </Grid>
        </EmphasizedContent>
    )
}

interface Props {
    salon: Club.Resources.Salon
}